import type { FC } from 'react';
import { useRecordContext } from 'react-admin';
import { Tooltip, Typography } from '@mui/material';
import type { Build } from '../../types';

/** "v2 · 3.1.3 (a1b2c3d)" — template, its version and the exact commit (feature 012). */
export const TemplateVersionField: FC<{ label?: string }> = () => {
  const record = useRecordContext<Build>();
  if (!record) return null;
  const parts = [record.templateKey || 'v1'];
  if (record.coreVersion) parts.push(record.coreVersion);
  const commit = record.templateCommit ? ` (${record.templateCommit.slice(0, 7)})` : '';
  const text = parts.join(' · ') + commit;
  return record.templateRef ? (
    <Tooltip title={`Источник: ${record.templateRef}${record.templateCommit ? ` @ ${record.templateCommit}` : ''}`}>
      <Typography variant="body2" component="span">{text}</Typography>
    </Tooltip>
  ) : (
    <Typography variant="body2" component="span">{text}</Typography>
  );
};
